// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"User_wrapper_2BZYx","user":"User_user_3OeJ7","avatar":"User_avatar_231tE","name":"User_name_26TuZ"};